export type InternationalTradeData = {
    id: number;
    categoryId: number;
    countryId: number;
    subCategoryId: number;
    type: InternationalTradeType;
} & (
     {
          unit: InternationalTradeUnit.money;
          year: number;
          value: AbsoluteValue;
      }
    | {
          unit: InternationalTradeUnit.percentage;
          year: string;
          value: PercentageValue;
      }
);

export interface AbsoluteValue extends Number {}
export interface PercentageValue extends Number {}

export enum InternationalTradeType {
    export = 0,
    import = 1
}

export enum InternationalTradeUnit {
    money = 0,
    percentage = 1
}